import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'plainText' })
export class PlainTextPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    // Decode HTML entities (handles &lt;span&gt; etc.)
    let decoded = value;
    for (let i = 0; i < 2; i++) { // decode twice to handle double-encoding
      const ta = document.createElement('textarea');
      ta.innerHTML = decoded;
      const next = ta.value;
      if (next === decoded) break;
      decoded = next;
    }

    // Strip tags (handles actual <span> etc.)
    return decoded.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  }
}